import script from "./TaxTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaxTable.vue?vue&type=script&lang=ts&setup=true"

import "./TaxTable.vue?vue&type=style&index=0&id=1c5530bb&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5530bb"]])

export default __exports__